<template>
    <div class="main-block request-management">
        <Breadcrumbs />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.userHistory') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns"  :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template #filter-slot>
                        <b-col lg="2" class="mt-3 mt-md-0">
                            <b-form-group :label="$t('title.users')" label-for="type-select" class="mb-0">
                                <treeselect :multiple="false" @input="handleFilter" v-model="filters.user"
                                            :placeholder="$t('title.select')"
                                            class="form-input"
                                            :options="users" />
                            </b-form-group>
                        </b-col>
                        <b-col lg="2" class="mt-3 mt-md-0">
                            <b-form-group :label="$t('title.Model')" label-for="type-select" class="mb-0">
                                <treeselect :multiple="false" @input="handleFilter" v-model="filters.item"
                                            :placeholder="$t('title.select')"
                                            class="form-input"
                                            :options="models" />
                            </b-form-group>
                        </b-col>
                    </template>
                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ $global.utcDateToLocalDate(item.created_at) }}
                            </span>
                        </div>
                    </template>
                </crud-table>
            </div>
        </div>
    </div>
</template>

<script>
import {request} from "@/Util/Request";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const FILTER_FORM = {
    user: null
};

const COLUMN_STATE = (self) => [
    {
        key: 'user_id',
        label: self.$t('title.user'),
        sortable: true
    },
    {
        key: 'item',
        label: self.$t('title.Model')
    },
    {
        key: 'action',
        label: self.$t('title.action'),
        sortable: true
    },
    {
        key: 'description',
        label: self.$t('title.description'),
        sortable: true
    },
    {
        key: 'created_at',
        label: self.$t('title.created_at'),
        sortable: true
    },
];

export default {
    data() {
        return {
            operation: '',
            query: {
                page: 1,
                perPage: 10,
            },
            pagination: {
                total: 0,
            },
            listUrl: 'admin/audit-trail',
            filters: { ...FILTER_FORM },
            showPopup: false,
            modalInstance: null, // Declare modalInstance here
            visibleFields: {},
            users: [],
            models: []
        };
    },
    components: { Breadcrumbs },
    mounted() {
        this.fetchUsers();
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleString();
        },
        handleFilter() {
            this.$refs['application-table'].handleFilter(this.filters);
        },
        resetFilter() {
            this.filters = { ...FILTER_FORM };
        },
        async fetchUsers() {
        try {

            const response = await request({
                method: 'get',
                url: `/admin/audit-trail/users`,
            });

            this.users = response.data;
            this.users.push({
                id: 'System Process',
                label: 'System Process'
            });

            this.models = response.items.map(record => ({
                id: record,
                label: record
            }));

            } catch (error) {
                console.log(error);
            }
        },
    },
    computed: {
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
